import axios from "axios";

import config from "config/global";
import { MediaObject } from "shared-types";

class MediaService {
  private url: string;

  constructor({ url }: { url: string }) {
    this.url = url;
  }

  public async get(
    id?: string,
    abortController?: AbortController
  ): Promise<MediaObject> {
    const { data } = await axios(`${this.url}/media/${id}`, {
      signal: abortController?.signal,
    });

    return data.value;
  }
}

export const titaniumApiUrl = config.titaniumApiUrl;

export default new MediaService({
  url: titaniumApiUrl,
});
